/// <amd-module name="Wit/LinkedWorkItemsDropdown/LinkedWorkItemsShelvesetDetailViewService" />
import { IWorkItemEntry } from "Util/Data";
import { IReadyableReadonlyObservableArray } from "VSS/Core/Observable";
import { IVssPageContext, IVssService, Services } from "VSS/Platform/Context";
import { LinkedWorkItemsBaseDetailViewService } from "./LinkedWorkItemsBaseDetailViewService";
import { getLinkedWorkItemsService } from "./LinkedWorkItemsService";

export interface ILinkedWorkItemsShelvesetDetailViewService extends IVssService {
    getLinkedWorkItems(projectId: string, repositoryId: string, shelvesetName: string): IReadyableReadonlyObservableArray<IWorkItemEntry>;
}

class LinkedWorkItemsShelvesetDetailViewService extends LinkedWorkItemsBaseDetailViewService implements ILinkedWorkItemsShelvesetDetailViewService {
    public getLinkedWorkItems(projectId: string, repositoryId: string, shelvesetName: string): IReadyableReadonlyObservableArray<IWorkItemEntry> {
        return super.getLinkedWorkItems(projectId, repositoryId, shelvesetName);
    }
    protected getLinkedWorkItemPromise(projectId: string, repositoryId: string, shelvesetName: string): Promise<number[]> {
        const linkedWorkItemService = getLinkedWorkItemsService(this.pageContext);
        return linkedWorkItemService.getLinkedShelvesetWorkItemIds(shelvesetName);
    }
}

const serviceName = "ILinkedWorkItemsShelvesetDetailViewService";
export function getLinkedWorkItemsShelvesetDetailViewService(pageContext: IVssPageContext): ILinkedWorkItemsShelvesetDetailViewService {
    return pageContext.getService<ILinkedWorkItemsShelvesetDetailViewService>(serviceName);
}

Services.add(serviceName, { serviceFactory: LinkedWorkItemsShelvesetDetailViewService });
